import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=316a7dc1&"
import script from "./QRCode.vue?vue&type=script&lang=js&"
export * from "./QRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports